import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import AuthSkeleton from "../components/SkeletonLoading/AuthSkeleton";

const PublicRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <AuthSkeleton />;
  }

  if (isAuthenticated) {
    return <Navigate to="/home/dashboard" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
